export const materialType = {
  'CC': 'Concrete',
  'CP': 'Copper',
  'ER': 'Earth',
  'FG': 'Fiberglass',
  'PL': 'Plastic',
  'ST': 'Steel',
  'WD': 'Wood',
  'AS': 'Asphalt', 
  'AC': 'Asbestos Cement',
  '': ''
};